import { render, staticRenderFns } from "./ServiceCompensationTab.vue?vue&type=template&id=bed29a28&scoped=true"
import script from "./ServiceCompensationTab.vue?vue&type=script&lang=js"
export * from "./ServiceCompensationTab.vue?vue&type=script&lang=js"
import style0 from "./ServiceCompensationTab.vue?vue&type=style&index=0&id=bed29a28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed29a28",
  null
  
)

export default component.exports